// utils/roundPriceStep.ts
export function roundPriceStep(n: number): number {
  if (typeof n !== "number" || !isFinite(n)) return 0;

  // работаем в целых центах
  const cents = Math.max(0, Math.round(n * 100 + 1e-6));
  const dollars = Math.floor(cents / 100);
  const frac = cents - dollars * 100; // 0..99

  if (frac === 0) return dollars;        // 13.00 -> 13
  if (frac <= 50) return dollars + 0.5;  // 13.01..13.50 -> 13.5
  return dollars + 1;                    // 13.51..13.99 -> 14
}
